module.exports = __webpack_public_path__ + "img/icon114.b6385ed7.png";